// @ts-ignore
import pdfMake from "pdfmake/build/pdfmake";
// @ts-ignore
import pdfFonts from "pdfmake/build/vfs_fonts";
// Import the images directly as modules
import logoImage from './logo_path.webp';
import staticOfferImage from './static_offer_path.webp';
import handImg1 from './count/img1.png';
import handImg2 from './count/img2.png';
import handImg3 from './count/img3.png';
import handImg4 from './count/img4.png';
import handImg5 from './count/img5.png';
import partyFaceImg from './party_face.png';

// Set up fonts for pdfmake
try {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
} catch (error) {
  console.warn('Fonts not available, using default fonts:', error);
  // Use empty vfs if fonts are not available
  pdfMake.vfs = {};
}

// Function to convert image to base64 for pdfMake
const convertImageToBase64 = (imageSrc: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = imageSrc;
  });
};

// Function to create static offer section
const createStaticOfferSection = (handImg1Base64: string, handImg2Base64: string, handImg3Base64: string, handImg4Base64: string, handImg5Base64: string) => {
  return {
    stack: [
      {
        table: {
          widths: [540], // Set width to 540px
          heights: [200], // Set height to 200px
          body: [
            [
              {
                stack: [
                  {
                    text: [
                      { text: 'WHY BUY FROM PRIME ', color: '#FFFFFF' },
                      { text: 'A', color: '#ed0505' },
                      { text: 'B', color: '#7a9441' },
                      { text: 'G', color: '#e36b09' },
                      { text: 'B', color: '#005D97' },
                      { text: '?', color: '#FFFFFF' }
                    ],
                    style: 'staticOfferTitle',
                    alignment: 'center',
                    margin: [0, 5, 0, 20]
                  },
                  {
                    columns: [
                      {
                        width: 40,
                        stack: [
                          {
                            image: handImg1Base64,
                            width: 25,
                            height: 25,
                            margin: [10, 0, 0, 0],
                            alignment: 'center'
                          }
                        ],
                        alignment: 'center'
                      },
                      {
                        width: '*',
                        text: '30 + Years of Experience in the Industry',
                        color: '#ed0505',
                        fontSize: 12,
                        margin: [0, 0, 10, 15],
                        alignment: 'left',
                        fontFamily: 'Arial',
                        bold: true
                      }
                    ]
                  },
                  {
                    columns: [
                      {
                        width: 40,
                        stack: [
                          {
                            image: handImg2Base64,
                            width: 25,
                            height: 25,
                            margin: [10, 0, 0, 0],
                            alignment: 'center'
                          }
                        ],
                        alignment: 'center'
                      },
                      {
                        width: '*',
                        text: 'Wide Range of High Quality Products',
                        color: '#7a9441',
                        fontSize: 12,
                        margin: [0, 0, 10, 15],
                        alignment: 'left',
                        fontFamily: 'Arial',
                        bold: true
                      }
                    ]
                  },
                  {
                    columns: [
                      {
                        width: 40,
                        stack: [
                          {
                            image: handImg3Base64,
                            width: 25,
                            height: 25,
                            margin: [10, 0, 0, 0],
                            alignment: 'center'
                          }
                        ],
                        alignment: 'center'
                      },
                      {
                        width: '*',
                        text: 'Expert Technical Support',
                        color: '#005D97',
                        fontSize: 12,
                        margin: [0, 0, 10, 15],
                        alignment: 'left',
                        fontFamily: 'Arial',
                        bold: true
                      }
                    ]
                  },
                  {
                    columns: [
                      {
                        width: 40,
                        stack: [
                          {
                            image: handImg4Base64,
                            width: 25,
                            height: 25,
                            margin: [10, 0, 0, 0],
                            alignment: 'center'
                          }
                        ],
                        alignment: 'center'
                      },
                      {
                        width: '*',
                        text: 'Free RMA Service',
                        color: '#e36b09',
                        fontSize: 12,
                        margin: [0, 0, 10, 15],
                        alignment: 'left',
                        fontFamily: 'Arial',
                        bold: true
                      }
                    ]
                  },
                  {
                    columns: [
                      {
                        width: 40,
                        stack: [
                          {
                            image: handImg5Base64,
                            width: 25,
                            height: 25,
                            margin: [10, 0, 0, 0],
                            alignment: 'center'
                          }
                        ],
                        alignment: 'center'
                      },
                      {
                        width: '*',
                        text: 'AMC & Technical Support on Premise (Quote will be Given on Request)',
                        color: '#FFFFFF',
                        fontSize: 12,
                        margin: [0, 0, 10, 0],
                        alignment: 'left',
                        fontFamily: 'Arial',
                        bold: true
                      }
                    ]
                  }
                ],
                fillColor: '#000000',
                border: [2, 2, 2, 2],
                borderColor: '#d9d9d9',
                margin: [30, 10, 30, 10]
              }
            ]
          ]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 0]
      }
    ]
  };
};

// Function to convert external image URL to base64 using Image element
const convertExternalImageToBase64 = async (imageUrl: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (!ctx) {
          reject(new Error('Failed to get canvas context'));
          return;
        }

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      } catch (error) {
        reject(new Error('Failed to convert image to base64'));
      }
    };

    img.onerror = () => {
      reject(new Error(`Failed to load image: ${imageUrl}`));
    };

    img.src = imageUrl;
  });
};

interface QuotationData {
  quotation_auto_id: string;
  quotation_date: string;
  validity: string;
  quotation_creation_type?: string;
  customer_details: {
    customer_name: string;
    email: string;
    mobile_no: string;
    address?: string;
    city?: string;
    state?: string;
    country?: string;
    pincode?: string;
    gstin?: string;
    contact_person_name?: string;
    contact_person_mobile_no?: string;
  };
  item_details: {
    [key: string]: Array<{
      category_name: string;
      item_name: string;
      quantity: number;
      selling_price: string;
      tax_rate: number;
      item_amount: number;
    }>;
  };
  description?: string;
  subtotal: string;
  total_gst_amount: string;
  quotation_total_amount: string;
  user_created_by_name: string;
  user_contact_no: string;
  user_email: string;
  images?: Array<{
    img_id: string;
    image: string;
    url: string | null;
  }>;
  assembly_charges?: { price: number };
  other_charges?: Array<{ name: string; price: number }> | { price: number };
  total_item_discount?: number;
}

// Define category order to match BuildYourPC form display
const categoryOrder = [
  'cpu',
  'motherboard',
  'memory', 'ram',
  'graphic card', 'graphics card', 'gpu',
  'storage', 'ssd', 'hdd', 'hard disk',
  'cabinet', 'case', 'chassis',
  'smps', 'power supply', 'psu',
  'cpu cooler',
  'cooler', 'fan',
  'cooling fans', 'fans'
];

// Function to get category sort priority
const getCategoryPriority = (categoryName: string): number => {
  const normalizedName = categoryName.toLowerCase().trim();

  // Find the best match by preferring exact matches, then prefix matches, then substring matches
  let bestIndex = -1;
  let bestScore = 0; // Higher score is better

  for (let i = 0; i < categoryOrder.length; i++) {
    const orderName = categoryOrder[i];
    let score = 0;

    if (normalizedName === orderName) {
      score = 100; // Exact match - highest priority
    } else if (normalizedName.startsWith(orderName) || orderName.startsWith(normalizedName)) {
      score = 50; // Prefix match - medium priority
    } else if (normalizedName.includes(orderName) || orderName.includes(normalizedName)) {
      score = 10; // Substring match - low priority
    }

    if (score > bestScore) {
      bestIndex = i;
      bestScore = score;
    }
  }

  return bestIndex === -1 ? 999 : bestIndex; // Unknown categories go last
};

// Reusable function to sort categories by priority
// For build_your_pc and template: sorts categories by priority
// Only sorts items within non-mandatory categories by sr_no (items with sr_no are from non-mandatory categories)
export const sortCategoriesByPriority = (item_details: { [key: string]: any[] }) => {
  return Object.entries(item_details || {})
    .sort(([keyA], [keyB]) => {
      const catA = item_details[keyA]?.[0]?.category_name || keyA;
      const catB = item_details[keyB]?.[0]?.category_name || keyB;
      const priorityA = getCategoryPriority(catA);
      const priorityB = getCategoryPriority(catB);
      return priorityA - priorityB;
    })
    .flatMap(([_, items]) => {
      // Only sort items by sr_no if they have sr_no (indicating non-mandatory category)
      // Items without sr_no are from mandatory categories and keep original order
      const hasSrNo = items.some((item: any) => item.sr_no !== undefined && item.sr_no !== null);

      if (hasSrNo) {
        // Non-mandatory category: sort by sr_no
        const sortedItems = [...items].sort((a: any, b: any) => {
          const srNoA = a.sr_no ?? Number.MAX_SAFE_INTEGER;
          const srNoB = b.sr_no ?? Number.MAX_SAFE_INTEGER;
          return srNoA - srNoB;
        });
        return sortedItems;
      } else {
        // Mandatory category: keep original order (no sr_no sorting)
        return items;
      }
    });
};

export const generateQuotationPDF = async (data: QuotationData, documentType: string = 'QUOTATION') => {
  const {
    quotation_auto_id,
    quotation_date,
    validity,
    quotation_creation_type,
    customer_details,
    item_details,
    description,
    subtotal,
    total_gst_amount,
    quotation_total_amount,
    user_created_by_name,
    user_contact_no,
    user_email,
    images,
    assembly_charges,
    other_charges,
    total_item_discount
  } = data;

  // Convert imported images to base64
  const logoBase64 = await convertImageToBase64(logoImage);
  const staticOfferBase64 = await convertImageToBase64(staticOfferImage);
  // const handImg1Base64 = await convertImageToBase64(handImg1);
  // const handImg2Base64 = await convertImageToBase64(handImg2);
  // const handImg3Base64 = await convertImageToBase64(handImg3);
  // const handImg4Base64 = await convertImageToBase64(handImg4);
  // const handImg5Base64 = await convertImageToBase64(handImg5);
  // const partyFaceBase64 = await convertImageToBase64(partyFaceImg);

  // Convert external images to base64
  const externalImagesBase64: string[] = [];
  const validImages: Array<{ base64: string; url: string | null }> = [];

  if (images && images.length > 0) {
    for (const imageData of images) {
      try {
        const base64Image = await convertExternalImageToBase64(imageData.image);
        externalImagesBase64.push(base64Image);
        validImages.push({ base64: base64Image, url: imageData.url });
      } catch (error) {
        console.error('Failed to convert image:', imageData.image, error);
        // Skip this image if conversion fails
      }
    }
  }

  const formatDate = (date: string): string => {
    const d = new Date(date);
    // e.g. "June 13, 2024"
    const month = d.toLocaleString('en-US', { month: 'long' });
    const day = d.getDate().toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${month} ${day}, ${year}`;
  };

  const formatCurrency = (amount: string | number): string => {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    return num.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const numberToWords = (num: number): string => {
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    if (num === 0) return 'Zero';
    if (num < 10) return ones[num];
    if (num < 20) return teens[num - 10];
    if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + ones[num % 10] : '');
    if (num < 1000) return ones[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + numberToWords(num % 100) : '');
    if (num < 100000) return numberToWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + numberToWords(num % 1000) : '');
    if (num < 10000000) return numberToWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + numberToWords(num % 100000) : '');
    return numberToWords(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + numberToWords(num % 10000000) : '');
  };

  // Sort categories by priority and flatten into one item list
  // For standalone quotations, sort by sr_no to preserve item order
  const allItems = quotation_creation_type === "standalone"
    ? (() => {
      // Flatten all items from all categories
      const flattenedItems = Object.entries(item_details || {}).flatMap(([_, items]) => items);
      // Sort by sr_no (items without sr_no go to end)
      return flattenedItems.sort((a: any, b: any) => {
        const srNoA = a.sr_no ?? Number.MAX_SAFE_INTEGER;
        const srNoB = b.sr_no ?? Number.MAX_SAFE_INTEGER;
        return srNoA - srNoB;
      });
    })()
    : sortCategoriesByPriority(item_details || {});

  // Build table body with proper columns matching HTML
  const tableBody = [
    [
      { text: "Category", style: "tableHeaderCategory" },
      { text: "Product Name", style: "tableHeader" },
      { text: "Rate", style: "tableHeader" },
      { text: "Qty", style: "tableHeader" },
      { text: "Total", style: "tableHeader" },
    ],
    // Add description row if description exists
    ...(description ? [[
      { text: `${description}`, colSpan: 5, style: "descriptionCell" },
      {},
      {},
      {},
      {}
    ]] : []),
    ...(allItems && allItems.length > 0 ? allItems.map((item: any, index: number) => [
      { text: item.category_name || '', style: index % 2 === 0 ? "tableCellEven" : "tableCellOdd" },
      { text: item.item_name || '', style: index % 2 === 0 ? "tableCellEven" : "tableCellOdd" },
      { text: `${formatCurrency(item.selling_price || 0)}`, style: index % 2 === 0 ? "tableCellEvenRight" : "tableCellOddRight" },
      { text: (item.quantity || 0).toString(), style: index % 2 === 0 ? "tableCellEvenCenter" : "tableCellOddCenter" },
      { text: `${formatCurrency(item.item_amount || 0)}`, style: index % 2 === 0 ? "tableCellEvenRight" : "tableCellOddRight" },
    ]) : []),
  ];

  // Build totals section
  const totalsRows = [
    { text: "Subtotal", style: "totalLabel" },
    { text: `${formatCurrency(subtotal || 0)}`, style: "totalAmount" }
  ];

  // Add assembly charges if present
  if (assembly_charges?.price && assembly_charges.price > 0) {
    totalsRows.push(
      { text: "Assembling and Testing Charges", style: "totalLabel" },
      { text: `${formatCurrency(assembly_charges.price)}`, style: "totalAmount" }
    );
  }

  // Add other charges if present
  if (other_charges) {
    if (Array.isArray(other_charges)) {
      other_charges.forEach((charge) => {
        if (charge.name && charge.price && charge.price > 0) {
          totalsRows.push(
            { text: charge.name, style: "totalLabel" },
            { text: `${formatCurrency(charge.price)}`, style: "totalAmount" }
          );
        }
      });
    } else if (other_charges.price && other_charges.price > 0) {
      totalsRows.push(
        { text: "Other Charges", style: "totalLabel" },
        { text: `${formatCurrency(other_charges.price)}`, style: "totalAmount" }
      );
    }
  }

  // Add discount if present
  if (total_item_discount && total_item_discount > 0) {
    totalsRows.push(
      { text: "Discount", style: "totalLabel" },
      { text: `${formatCurrency(total_item_discount)}`, style: "totalAmount" }
    );
  }

  // Add tax
  totalsRows.push(
    { text: "Tax (18%)", style: "totalLabel" },
    { text: `${formatCurrency(total_gst_amount)}`, style: "totalAmount" }
  );

  // Add net total
  totalsRows.push(
    { text: "Net Total", style: "netTotalLabel" },
    { text: `₹${formatCurrency(quotation_total_amount)}`, style: "netTotalAmount" }
  );

  //*// The header dynamic dates
    const rightField = (label: any, value: any, width?: any, extra = {}) => ({
        width,
        text: [
            { text: label, fontSize: 9 },
            { text: value, fontSize: 9, bold: true }
        ],
        alignment: 'right',
        ...extra
    });
    const isProforma = documentType === 'PRO FORMA INVOICE';
    const headerColumns = isProforma
        ? [
            rightField('Date: ', formatDate(quotation_date)),
            rightField('No: ', quotation_auto_id, undefined, { margin: [10, 0, 0, 0] })
        ]
        : [
            rightField('Creation Date: ', formatDate(quotation_date), 160),
            rightField('Validity Date: ', formatDate(validity), 160),
            rightField('No: ', quotation_auto_id, 80)
        ];


  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [30, 155, 30, 10],
    // background: function(currentPage: number, pageSize: any) {
    //   return [
    //     {
    //       // Draw a red rectangle border around the page
    //       canvas: [
    //         {
    //           type: 'rect',
    //           x: 6,
    //           y: 6,
    //           w: pageSize.width - 12,
    //           h: pageSize.height - 12,
    //           lineColor: '#ff0000',
    //           lineWidth: 2,
    //           r: 0 // no radius
    //         }
    //       ]
    //     }
    //   ];
    // },
    // Increased top margin for header space
    header: function (currentPage: number, pageCount: number) {
      return {
        stack: [
          // Logo and motto section
          {
            columns: [
              {
                width: '60%',
                stack: [
                  {
                    image: logoBase64,
                    width: 180,
                    alignment: 'left'
                  }
                ]
              },
              {
                width: '40%',
                text: [
                  { text: 'A', color: '#ed0505', fontSize: 14 },
                  { text: 'lways ', color: '#000000', fontSize: 14 },
                  { text: 'B', color: '#7a9441', fontSize: 14 },
                  { text: 'elieve ', color: '#000000', fontSize: 14 },
                  { text: 'i', color: '#000000', fontSize: 14 },
                  { text: 'n ', color: '#000000', fontSize: 14 },
                  { text: 'G', color: '#e36b09', fontSize: 14 },
                  { text: 'etting ', color: '#000000', fontSize: 14 },
                  { text: 'B', color: '#005D97', fontSize: 14 },
                  { text: 'etter', color: '#000000', fontSize: 14 }
                ],
                alignment: 'right',
                margin: [0, 20, 0, 0]
              }
            ],
          },
          // Top horizontal line
          {
            canvas: [{ type: 'line', x1: 0, y1: 0, x2: 540, y2: 0, lineWidth: 1, lineColor: '#ccc' }],
            margin: [0, 8, 0, 8]
          },
          // Address section
          {
            stack: [
              {
                columns: [
                  {
                    width: '40%',
                    stack: [
                      {text: 'Prime ABGB Pvt. Ltd.', fontSize: 9, bold: true, color: '#333' },
                      { text: 'Simlim Square, 106-109, 1st Floor,', fontSize: 8, color: '#333' },
                      { text: 'Lamington Road, Grant Road East, Mumbai- 400 007.', fontSize: 8, color: '#333' }
                    ]
                  },
                  {
                    width: '30%',
                    text: '+91-22-67402000',
                    fontSize: 8,
                    color: '#333',
                    alignment: 'right',
                    margin: [0, 8, 0, 0]
                  },
                  {
                    width: '30%',
                    stack: [
                      { text: 'sales@primeabgb.com', fontSize: 8, color: '#333', alignment: 'right' },
                      { text: 'www.primeabgb.com', fontSize: 8, color: '#333', alignment: 'right' }
                    ]
                  }
                ]
              },
              {
                text: 'GSTIN No: 27AABCP6338G1ZD',
                fontSize: 8,
                color: '#333',
                margin: [0, 2, 0, 0]
              }
            ]
          },
          // Bottom horizontal line
          {
            canvas: [{ type: 'line', x1: 0, y1: 0, x2: 540, y2: 0, lineWidth: 1, lineColor: '#ccc' }],
            margin: [0, 8, 0, 8]
          }
        ],
        margin: [30, 20, 30, 10]
      };
    },
    content: [
      // Quotation Title and Date
      {
        columns: [
          {
            width: 'auto',
            text: documentType,
            fontSize: documentType.length > 10 ? 11 : 14,
            bold: true,
            color: '#000000',
            margin: [0, 5, 0, 0]
          },
          {
            canvas: documentType.length > 10 ? [{ type: 'line', x1: 0, y1: 0, x2: 418, y2: 0, lineWidth: 2, lineColor: '#005D97' }] : [{ type: 'line', x1: 0, y1: 0, x2: 445, y2: 0, lineWidth: 2, lineColor: '#005D97' }],
            margin: [10, 12, 0, 0]
          }
        ]
      },
      {
        columns: [
          { width: '*', text: '' },
          {
            width: isProforma ? 'auto' : 400,
            columns: headerColumns
          }
        ]
      },
      {
        text: [
          { text: 'Invoice ', fontSize: 9, bold: true, color: '#000000' },
          { text: 'TO', fontSize: 12, bold: true, color: '#1da9ff' }
        ],
        margin: [0, 10, 0, 5]
      },
      { text: `${customer_details.customer_name}`, fontSize: 9, bold: true, margin: [0, 0, 0, 2] },

      // Show address if present
      ...(customer_details.address ? [{ text: `${customer_details.address}`, fontSize: 8, margin: [0, 0, 0, 2] }] : []),

      // Show city, state, country, pincode if present
      ...(customer_details.city || customer_details.state || customer_details.country || customer_details.pincode ?
        [{ text: `${[customer_details.city, customer_details.state, customer_details.country, customer_details.pincode].filter(Boolean).join(', ')}`, fontSize: 8, margin: [0, 0, 0, 2] }] : []),

      { text: `${customer_details.email}, ${customer_details.mobile_no}`, fontSize: 8, margin: [0, 0, 0, 5] },

      // Show GSTIN if present
      ...(customer_details.gstin ? [{ text: `GSTIN: ${customer_details.gstin}`, fontSize: 8, margin: [0, 0, 0, 2] }] : []),


      // { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#000000' }], margin: [0, 10, 0, 10] },

      // Item Details Table
      {
        table: {
          headerRows: 1,
          widths: [80, '*', 60, 40, 60],
          body: tableBody,
        },
        layout: {
          hLineWidth: function (i: any, node: any) {
            return i === 0 ? 0 : 1;
          },
          vLineWidth: function (i: any, node: any) {
            return 1;
          },
          hLineColor: function (i: any, node: any) {
            return i === 0 ? '#000000' : '#e0e0e0';
          },
          vLineColor: function (i: any, node: any) {
            return '#e0e0e0';
          },
        }
      },

      // { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#000000' }], margin: [0, 10, 0, 10] },

      // Totals Section
      {
        columns: [
          { width: '*', text: '' },
          {
            width: 280,
            table: {
              widths: [160, 120],
              body: totalsRows.reduce((acc: any[], _, index) => {
                if (index % 2 === 0 && totalsRows[index] && totalsRows[index + 1]) {
                  acc.push([
                    { text: totalsRows[index].text || '', style: 'totalLabel' },
                    { text: totalsRows[index + 1].text || '', style: 'totalAmount' }
                  ]);
                }
                return acc;
              }, [])
            },
            layout: {
              hLineWidth: function (i: any, node: any) {
                return i === 0 ? 0 : 1;
              },
              vLineWidth: function (i: any, node: any) {
                return 0;
              },
              hLineColor: function (i: any, node: any) {
                return i === 0 ? '#000000' : '#e0e0e0';
              },
              vLineColor: function (i: any, node: any) {
                return '#000000';
              },
            }
          },
          { width: 15, text: '' } // Right spacer to shift left
        ],
        margin: [0, 5, 0, 10]
      },

      // Amount in words
      {
        columns: [
          { width: '*', text: '' },
          {
            width: 320,
            text: `(Amount in words: ${(() => {
              const amount = parseFloat(quotation_total_amount || '0');
              const rupees = Math.floor(amount);
              const paise = Math.round((amount % 1) * 100);

              if (paise > 0) {
                return `${numberToWords(rupees)} And ${numberToWords(paise)} Paise Only`;
              } else {
                return `${numberToWords(rupees)} Only`;
              }
            })()})`,
            fontSize: 8,
            alignment: 'right',
            margin: [0, 5, 0, 10]
          }
        ]
      },

      // { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#000000' }], margin: [0, 10, 0, 10] },

      // Bank Details
      {
        table: {
          widths: ['*'],
          body: [
            [
              {
                text: [
                  { text: 'Our Bank Details: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
                  { text: 'Account Name: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
                  { text: 'Prime ABGB Pvt. Ltd., ', fontSize: 7, fontFamily: 'Segoe UI', color: '#2c3e50' },
                  { text: 'Bank Name: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
                  { text: 'ICICI Bank Ltd, ', fontSize: 7, fontFamily: 'Segoe UI', color: '#2c3e50' },
                  { text: 'A/c No: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
                  { text: '034805006144', fontSize: 7, fontFamily: 'Segoe UI', color: '#2c3e50' }
                ],
                border: [true, true, true, true],
                fillColor: '#f5f5f5',
                alignment: 'center',
                margin: [50, 8, 50, 0]
              }
            ],
            [
              {
                text: [
                  { text: 'Account Type: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
                  { text: 'Current, ', fontSize: 7, fontFamily: 'Segoe UI', color: '#2c3e50' },
                  { text: 'Branch: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
                  { text: 'Opera House, ', fontSize: 7, fontFamily: 'Segoe UI', color: '#2c3e50' },
                  { text: 'IFSC Code: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
                  { text: 'ICIC0000348', fontSize: 7, fontFamily: 'Segoe UI', color: '#2c3e50' }
                ],
                border: [true, true, true, true],
                fillColor: '#f5f5f5',
                alignment: 'center',
                margin: [50, 0, 50, 8]
              }
            ]
          ]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 10]
      },

      // { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#000000' }], margin: [0, 10, 0, 10] },

      // Sales Person Details
      {
        text: [
          { text: 'Sales Person Name: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
          { text: `${user_created_by_name}`, fontSize: 8, fontFamily: 'Segoe UI', color: '#2c3e50' },
          { text: ' , ', fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
          { text: 'Contact Number: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
          { text: `${user_contact_no}`, fontSize: 8, fontFamily: 'Segoe UI', color: '#2c3e50' },
          { text: ' , ', fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
          { text: 'Email ID: ', bold: true, fontSize: 8, fontFamily: 'Segoe UI', color: '#333' },
          { text: `${user_email}`, fontSize: 8, color: '#1da9ff', fontFamily: 'Segoe UI' }
        ],
        alignment: 'center',
        margin: [0, 0, 0, 10]
      },

      // { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#000000' }], margin: [0, 10, 0, 10] },

      // Terms and Conditions
      {
        table: {
          widths: ['*'],
          body: [[
            {
              stack: [
                {
                  text: 'Additional Details:',
                  fontSize: 9,
                  bold: true,
                  alignment: 'left',
                  margin: [0, 0, 0, 5],
                  fontFamily: 'Segoe UI',
                  color: '#333',
                  lineHeight: 1.3
                },
                {
                  ol: [
                    'Quotation Validity – All quotations are valid as per the validity date mentioned on quotation',
                    'Pricing & GST – Prices include 18% GST. A proper GST invoice will be provided.',
                    'Advance Payment – Orders can be confirmed with 50% advance payment; balance is due before dispatch.',
                    'Warranty – Standard warranty as per brand policy; extended warranty available at extra cost.',
                    'Testing & Quality – Every PC undergoes a 32 Point Test.',
                    'Technical Support – Online tech support is available for setup and troubleshooting.',
                    'AMC Option – Annual Maintenance Contracts (AMC) are available at additional cost.'
                  ],
                  fontSize: 8,
                  margin: [0, 0, 0, 0],
                  fontFamily: 'Segoe UI',
                  color: '#2c3e50',
                  lineHeight: 1.3
                }
              ],
              border: [true, true, true, true],
              fillColor: '#f5f5f5',
              margin: [8, 8, 8, 8]
            }
          ]]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 0],
        unbreakable: true
      },

      // Page Break for Special Offers
      { text: '', pageBreak: 'before' },

      // Special Offers Section
      {
        table: {
          widths: [540],
          body: [[
            {
              columns: [
                {
                  width: '*',
                  text: 'SPECIAL OFFERS',
                  fontSize: 12,
                  bold: true,
                  color: '#FFFFFF',
                  alignment: 'center',
                  margin: [0, 0, 0, 0]
                }
              ],
              fillColor: '#005D97',
              margin: [0, 3, 0, 3],
              letterSpacing: 2
            }
          ]]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 0]
      },

      // Dynamic Images Section
      ...(validImages.length > 0 ? validImages.map((imageData, index) => {
        const imageElement: any = {
          image: imageData.base64,
          width: 540,
          height: 330,
          margin: [0, 1, 0, 1],
          fit: [540, 330],
          stretch: true,
          preserveAspectRatio: false
        };

        // Add clickable link if URL is provided
        if (imageData.url) {
          const link = imageData.url.startsWith('http')
            ? imageData.url
            : `https://${imageData.url}`;
          imageElement.link = link;
        }

        return imageElement;
      }) : []),

      // Static Offer Section - Replace image with static content
      // {
      //   ...createStaticOfferSection(handImg1Base64, handImg2Base64, handImg3Base64, handImg4Base64, handImg5Base64),
      //   margin: [0, 1, 0, 0]
      // }

      {
        image: staticOfferBase64,
        width: 540,
        height: 280,
        margin: [0, 1, 0, 1],
        stretch: true,
        preserveAspectRatio: false
      },

    ],

    styles: {
      staticOfferTitle: {
        fontSize: 18,
        bold: true,
        color: '#FFFFFF',
        alignment: 'center',
        margin: [0, 0, 0, 20],
        letterSpacing: 1.2
      },
      tableHeader: {
        fontSize: 9,
        bold: true,
        color: '#FFFFFF',
        fillColor: '#000000',
        alignment: 'center',
        margin: [4, 4, 4, 4]
      },
      tableHeaderCategory: {
        fontSize: 9,
        bold: true,
        color: '#FFFFFF',
        fillColor: '#005D97',
        alignment: 'center',
        margin: [4, 4, 4, 4]
      },
      tableCellEven: {
        fontSize: 8,
        margin: [2, 2, 2, 2],
        fontFamily: 'Helvetica',
        fillColor: '#f2f2f2',
        alignment: 'left'
      },
      tableCellOdd: {
        fontSize: 8,
        margin: [2, 2, 2, 2],
        fontFamily: 'Helvetica',
        fillColor: '#ffffff',
        alignment: 'left'
      },
      tableCellEvenCenter: {
        fontSize: 8,
        margin: [2, 2, 2, 2],
        fontFamily: 'Helvetica',
        fillColor: '#f2f2f2',
        alignment: 'center'
      },
      tableCellOddCenter: {
        fontSize: 8,
        margin: [2, 2, 2, 2],
        fontFamily: 'Helvetica',
        fillColor: '#ffffff',
        alignment: 'center'
      },
      tableCellEvenRight: {
        fontSize: 8,
        margin: [2, 2, 2, 2],
        fontFamily: 'Helvetica',
        fillColor: '#f2f2f2',
        alignment: 'right'
      },
      tableCellOddRight: {
        fontSize: 8,
        margin: [2, 2, 2, 2],
        fontFamily: 'Helvetica',
        fillColor: '#ffffff',
        alignment: 'right'
      },
      tableCell: {
        fontSize: 8,
        margin: [2, 2, 2, 2],
        fontFamily: 'Helvetica'
      },
      descriptionCell: {
        fontSize: 9,
        margin: [4, 4, 4, 4],
        fontFamily: 'Helvetica',
        fillColor: '#ffffff',
        // color: '#495057',
        // bold: true,
        alignment: 'left'
      },
      totalLabel: {
        fontSize: 9,
        alignment: 'left',
        fillColor: '#f2f6fb',
        color: '#000',
        bold: true,
        margin: [4, 4, 4, 4]
      },
      totalAmount: {
        fontSize: 9,
        alignment: 'right',
        fillColor: '#005D97',
        color: '#fff',
        margin: [4, 4, 4, 4],
        fontFamily: 'Helvetica'
      },
      netTotalLabel: {
        fontSize: 9,
        bold: true,
        alignment: 'left',
        fillColor: '#f2f6fb',
        color: '#000',
        margin: [4, 4, 4, 4]
      },
      netTotalAmount: {
        fontSize: 9,
        bold: true,
        alignment: 'right',
        fillColor: '#005D97',
        color: '#fff',
        margin: [4, 4, 4, 4],
        fontFamily: 'Helvetica'
      }
    },

    defaultStyle: {
      fontSize: 9,
      fontFamily: 'Helvetica'
    }
  };

  return docDefinition;
};

